export const searchFlightAction = {
    SEARCHFLIGHT:"SEARCHFLIGHT",
    SAVETOKEN:"SAVETOKEN",
    SAVERECENTSEARCH:"SAVERECENTSEARCH",
    UPDATEFLIGHTREQUEST:"UPDATEFLIGHTREQUEST",
    SAVESEARCHRESULT:"SAVESEARCHRESULT"

}   